<template>
  <div>
    <Head title="Delivery Run Packed Sku Orders" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" :href="`/dispatches/delivery-runs/${delivery_run.id}/packed/orders`">Delivery Runs</Link>
      <span class="text-orange-400 font-medium">/</span>{{ delivery_run.number }}/{{ user.username }}/Orders/{{ order.order_no }}
    </h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="search.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <div v-show="order.status !=10 && order.status !=12 && order.status !=13 && order.status !=16" class="flex items-end justify-end space-x-3">
        <label
          class="mb-4"
        >
          <strong>Status</strong>
        </label>
        <select-input
          v-if="order.status !=15"
          v-model="form.status"
          class="w-full lg:w-full"
          @change="deliveredOrderModel"
        >
          <option
            :value="null"
          >
            Select Status
          </option>
          <option
            value="delivered"
          >
            Delivered
          </option>
          <option
            value="partially-delivered"
          >
            Partially Delivered
          </option>
          <option
            value="cancelled-at-delivery"
          >
            Cancelled at Delivery
          </option>
          <option
            value="rescheduled"
          >
            Rescheduled
          </option>
        </select-input>
        <select-input
          v-else
          v-model="form.status"
          class="w-full lg:w-full"
          @change="deliveredOrderModel"
        >
          <option
            :value="null"
          >
            Select Status
          </option>
          <option
            value="return-picked"
          >
            Return Picked
          </option>
        </select-input>
        <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
          <a
            class="btn btn-orange text-xs cursor-pointer ml-1 mr-1"
            :href="`/orders/${order.id}/pdf${pdfUrl(order.id)}`" 
            download
            target="__blank"
            title="Download"
          >
            <span>Download Invoice</span>
          </a>
        </span>
      </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <div class="px-2 py-2 mb-3 mt-3">
        <h1 class="mb-3 text-1xl">
          <strong>Customer: </strong> {{ customer.name }}
        </h1>
        <h1 class="mb-3 text-1xl">
          <strong>Contact: </strong>{{ customer.phone }}
        </h1>
        <h1 class="mb-3 text-1xl">
          <strong>Physcial Address: </strong>{{ customer.physical_address }}
        </h1>
        <h1 class="mb-3 text-1xl">
          <strong>Channel: </strong> {{ customer.channel }}
        </h1>
        <h1 class="mb-3 text-1xl">
          <strong>Region: </strong>{{ customer.region }}
        </h1>
        <h1 class="mb-3 text-1xl">
          <strong>City: </strong>{{ customer.city }}
        </h1>
      </div>
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Part Number</th>
          <th class="pb-3 pt-3 px-3">Part Description</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Ordered</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Packed</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Delivered</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Returned</th>
          <th class="pb-3 pt-3 px-3 text-center">Quantity Received</th>
          <th class="pb-3 pt-3 px-3 text-center">Volume</th>
          <th class="pb-3 pt-3 px-3">UoM</th>
          <th class="pb-3 pt-3 px-3">Reason</th>
          <th class="pb-3 pt-3 px-3 flex items-end px-3 justify-end">Amount</th>
        </tr>
        <tr v-for="list in order_details" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ list.sku }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ list.description }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
              {{ list.quantity }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
              {{ list.quantity_picked }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
              {{ list.quantity_delivered }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
              {{ list.quantity_returned }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
              {{ list.quantity_received }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center justify-center px-3 py-3 focus:text-orange-500">
              {{ list.volume }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center  px-3 py-3 focus:text-orange-500">
              {{ list.measure }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center  px-3 py-3 focus:text-orange-500">
              {{ list.reason }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-end justify-end  px-3 py-3 focus:text-orange-500">
              {{ list.amount }}
            </span>
          </td>
        </tr>
        <tr v-if="order_details.length === 0">
          <td class="px-3 py-3 border-t" colspan="5">No data found</td>
        </tr>
      </table>
    </div>
    <h1 v-if="payments.length" class="text-2xl mt-3">Payments</h1>
    <div v-if="payments.length" class="bg-white rounded-md shadow overflow-x-auto">
      <div class="px-2 py-2 mb-3 mt-3">
        <table v-if="payments.length" class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="pb-3 pt-3 px-3">Date</th>
            <th class="pb-3 pt-3 px-3">Provider</th>
            <th class="pb-3 pt-3 px-3">Reference</th>
            <th class="pb-3 pt-3 px-3 flex items-end px-3 justify-end">Amount</th>
          </tr>
          <tr v-for="list in payments" :key="list.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
            <td class="border-t">
              <span class="flex items-center px-3 py-3 focus:text-orange-500">
                {{ list.date }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center  px-3 py-3 focus:text-orange-500">
                {{ list.provider }}
              </span>
            </td>
            <td class="border-t">
              <span class="flex items-center  px-3 py-3 focus:text-orange-500">
                {{ list.code }}
              </span>
            </td>
            <td class="border-t flex items-end px-3 justify-end">
              <span class="flex items-end px-3 justify-end  px-3 py-3 focus:text-orange-500">
                {{ list.amount }}
              </span>
            </td>
          </tr>
          <tr v-if="order_details.length === 0">
            <td class="px-3 py-3 border-t" colspan="5">No data found</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <!--modal content-->
  <div v-if="isOpen && form.status" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex flex-wrap w-full items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-2 sm:align-middle w-1/2" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1 v-if="form.status=='rescheduled'">Reschedule Order</h1>
            <h1 v-else>Mark an Order as {{ form.status.replace(/-/g, ' ') }}</h1>
          </div>
          <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <p v-show="form.status=='delivered'">
                You are about to mark this order {{ order.order_no }} as <strong>{{ form.status }}</strong>.
                Do you wish to continue?
              </p>
              <p v-show="form.status=='partially-delivered'" style="color: #fff">
                You are about to mark this order {{ order.order_no }} as <strong>{{ form.status.replace(/-/g, ' ') }}</strong>.
                Do you wish to continue? You are about to mark this order {{ order.order_no }} as <strong>{{ form.status }}</strong>.
              </p>
              <div
                v-show="form.status=='return-picked'"
                class="w-full"
              >
                <div
                  v-for="(partial, index) in form.orders"
                  :key="index"
                  class="flex flex-wrap w-full"
                >
                  <div class="pb-2 pr-6 w-full lg:w-full">
                    <text-input
                      :key="index"
                      v-model="partial.quantity_delivered"
                      :error="showValidationErrors(`orders.${index}.quantity_delivered`)"
                      placeholder="Quantity"
                      :label="`${partial.label}`"
                    />
                  </div>
                  <div class="pb-2 pr-6 w-full lg:w-full">
                    <text-input
                      :key="index"
                      v-model="partial.id"
                      :error="form.errors.id"
                      class="pb-2 hidden"
                      placeholder="ID"
                    />
                  </div>
                </div>
              </div>
              <div
                v-show="form.status=='partially-delivered'"
                class="w-full"
              >
                <div
                  v-for="(partial, index) in form.orders"
                  :key="index"
                  class="flex flex-wrap w-full"
                >
                  <div class="pb-2 pr-6 w-1/2 lg:w-1/2">
                    <text-input
                      :key="index"
                      v-model="partial.quantity_delivered"
                      :error="showValidationErrors(`orders.${index}.quantity_delivered`)"
                      placeholder="Quantity"
                      :label="`${partial.label}`"
                    />
                  </div>
                  <div class="w-1/2 lg:w-1/2 pb-2 pr-6">
                    <label class="form-label"> Reason:</label>
                    <multiselect
                      id="order_delivery_reason_id"
                      v-model="partial.order_delivery_reason_id"
                      placeholder="Search Reason"
                      :options="order_delivery_reasons"
                      :close-on-select="true"
                      :searchable="true"
                      :error="showValidationErrors(`orders.${index}.order_delivery_reason_id`)"
                      :style="showValidationErrors(`orders.${index}.order_delivery_reason_id`) ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                      @input="onSelectedPartialReason"
                    />
                    <div v-if="showValidationErrors(`orders.${index}.order_delivery_reason_id`)" class="form-error">{{ showValidationErrors(`orders.${index}.order_delivery_reason_id`) }}</div>
                  </div>
                  <div class="pb-2 pr-6 w-full lg:w-full">
                    <text-input
                      :key="index"
                      v-model="partial.id"
                      :error="form.errors.id"
                      class="pb-2 hidden"
                      placeholder="ID"
                    />
                  </div>
                </div>
              </div>
              <div
                v-show="form.status=='rescheduled'"
                class="w-full pt-5"
              >
                <div
                  class="flex flex-wrap w-full"
                >

                  <div class="pb-2 pr-6 w-1/2 lg:w-1/2">
                  <label>Reschedule Date</label>
                    <text-input
                      type="date"
                      v-model="form.reschedule_date"
                      class="pb-2 mt-2 w-full"
                      placeholder="Reschedule Date"
                    />
                    <div v-if="form.errors.reschedule_date" class="form-error">{{ form.errors.reschedule_date }}</div>
                  </div>
                  <div class="w-1/2 lg:w-1/2 pb-2 pr-6">
                    <label class="mb-2">Destination</label>
                  <multiselect
                    id="order_cancellation_reason_id"
                    v-model="form.reschedule_destination"
                    placeholder="Search Reschedule Destination"
                    :options="order_reschedule_destinations"
                    :close-on-select="true"
                    :searchable="true"
                    :error="form.errors.reschedule_destination"
                    :style="form.errors.reschedule_destination ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                    @input="onSelectedCancellationReason"
                    class="mt-2"
                  />
                  <div v-if="form.errors.reschedule_destination" class="form-error">{{ form.errors.reschedule_destination }}</div>
                </div>
                  <p v-show="form.status=='rescheduled'" />
                </div>
              </div>
              <div
                v-show="form.status=='cancelled-at-delivery'"
                class="w-full"
              >
                <div class="w-full lg:w-full pb-2 pr-6">
                  <multiselect
                    id="order_cancellation_reason_id"
                    v-model="selectedCancellationReason"
                    placeholder="Search Reason"
                    :options="order_cancellation_reasons"
                    :close-on-select="true"
                    :searchable="true"
                    :error="form.errors.order_cancellation_reason_id"
                    :style="form.errors.order_cancellation_reason_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
                    @input="onSelectedCancellationReason"
                  />
                  <div v-if="form.errors.order_cancellation_reason_id" class="form-error">{{ form.errors.order_cancellation_reason_id }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button v-if="form.status=='return-picked'" type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5" @click="updateOrder()">
                Continue
              </button>
              <button v-else type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5" @click="updateOrder()">
                Continue
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeModal">
                Cancel
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
        
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import SelectInput from '@/Shared/SelectInput'
import TextInput from '@/Shared/TextInput'
import Multiselect from '@vueform/multiselect'
        
export default {
  components: {
    Head,
    Link,
    SearchFilter,
    Pagination,
    SelectInput,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  props: {
    filters: Object,
    order: Object,
    delivery_run: Object,
    order_details: Object,
    user: Object,
    customer: Object,
    orders: Object,
    order_cancellation_reasons: Object,
    is_partial: Number,
    order_delivery_reasons: Object,
    is_order_complete: Boolean,
    delivery_fees: Object,
    payments: Object,
    order_reschedule_destinations: Array,
  },
  data() {
    return {
      isOpen: false,
      status: null,
      form: this.$inertia.form({
        status: null,
        orders: this.orders,
        order_id: this.order.id,
        delivery_run_id: this.delivery_run.id,
        order_cancellation_reason_id: null,
        reschedule_date: null,
        reschedule_destination: null,
      }),
      search: {
        search: this.filters.search,
      },
      selectedCancellationReason: null,
    }
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/dispatches/delivery-runs/${this.delivery_run.id}/orders/${this.order.id}/packed/skus`, pickBy(this.search), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.search, () => null)
    },
    isValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || ''
        return !!error
      }
      return false
    },
    showValidationErrors(value) {
      if (this.form.errors) {
        const error = this.form.errors[value] || ''
        return error || ''
      }
      return ''
    },
    updateOrder() {
      this.form.post(`/dispatches/delivery-runs/${this.delivery_run.id}/orders/${this.order.id}/deliver`, {
        onSuccess: () => {
          this.form.reset(
            'orders',
            'order_cancellation_reason_id',
            'reschedule_date',
          )
          this.isOpen = false
          this.selectedCancellationReason = null
        },
      })      
    },
    deliveredOrderModel() {
      this.isOpen = true
    },
    closeModal() {
      this.form.status = this.status
      this.isOpen = false
      this.form.errors = {
        id: null,
        quantity_delivered: null,
      }
      this.selectedCancellationReason = null
      this.selectedPartialReason = null
    },
    onSelectedCancellationReason(order_cancellation_reason_id, id) {
      this.form.order_cancellation_reason_id = order_cancellation_reason_id
      this.selectedCancellationReason = order_cancellation_reason_id
    },
    onSelectedPartialReason(order_delivery_reason_id, id) {
      this.form.orders.order_delivery_reason_id = order_delivery_reason_id
    },
    pdfUrl(orderId) {
      let query = ''
      if (orderId) {
        query += `oid=${this.order.id}`
      }
      if (query) {
        query = `?${query}`
      }
      return query
    },
  },
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style type="text/css">
  .multiselect-option.is-selected.is-pointed {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .multiselect-option.is-selected {
    background: var(--ms-option-bg-selected-pointed,#fb923c);
    color: var(--ms-option-color-selected-pointed,#fff);
  }
  .modal-wrapper h1 {
    font-size: 20px;
    font-weight:bold;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .multiselect {
    margin-top: 7px;
  }
</style>